module.exports = __webpack_public_path__ + "static/media/portfolioProfileImage.94bb1297.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Artist/static/images/portfolioProfileImage.png
// module id = 113
// module chunks = 1